// The changelist server's per-request caps. The client splits larger sets
// to fit them, and the mock server enforces them, so both use these numbers.

/** Pull requests the server accepts in one `/api/attention/batch` request. */
export const ATTENTION_BATCH_MAX = 100;

/** Marks the server accepts in one marks PUT. */
export const MARKS_PER_PUT = 5000;

/** Blobs the server accepts in one marks lookup, over all its paths. */
export const MARKS_LOOKUP_BLOBS = 10_000;

/** Flags the server accepts in one flags PUT. */
export const FLAGS_PER_PUT = 500;
